<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto" class="d-flex align-center">
                <v-btn icon variant="text" class="mr-1" @click="tornaIndietro">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <h2 class="text-h6">Clienti</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuovo cliente</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(item)">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="elimina(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="480">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica cliente' : 'Nuovo cliente' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-text-field v-model="form.nome" label="Nome" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="form.partitaIva" label="Partita IVA" />
                        <v-textarea v-model="form.note" label="Note" rows="2" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "ClientiPage",

    data() {
        return {
            dialog: false,
            form: this.formVuoto(),
            headers: [
                { title: "Nome", key: "nome" },
                { title: "Partita IVA", key: "partitaIva" },
                { title: "Note", key: "note" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        lista() {
            return this.$store.getters["clienti/lista"];
        },
    },

    mounted() {
        this.$store.dispatch("clienti/carica");
    },

    methods: {
        tornaIndietro() {
            this.$router.push("/incassi");
        },

        formVuoto() {
            return { id: null, nome: "", partitaIva: "", note: "" };
        },

        apriDialog(item) {
            this.form = item ? { ...item } : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            try {
                const { id, ...dati } = this.form;
                await this.$store.dispatch("clienti/salva", { id, dati });
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
        },

        async elimina(item) {
            try {
                await this.$store.dispatch("clienti/elimina", item.id);
            } catch (error) {
                console.log(error);
            }
        },

        async duplica(item) {
            try {
                await this.$store.dispatch("clienti/duplica", item.id);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
